module.exports = {
      id: "pln-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#pln-usage",
      toString: function () {
        return this.url;
      }
    }